"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BentoItemLink = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const blueprint_1 = require("@groma-dev/blueprint");
const BentoItemLink_module_scss_1 = __importDefault(require("./BentoItemLink.module.scss"));
/**
 * Link usage inside the `<BentoPanel />` component to render link items for various experiences
 * @param props
 * @constructor
 */
const BentoItemLink = (props) => {
    const { children, href, testId, className } = props, args = __rest(props, ["children", "href", "testId", "className"]);
    const dti = (0, blueprint_1.getTestIdAttribute)(testId);
    return ((0, jsx_runtime_1.jsx)("a", Object.assign({}, args, { className: (0, blueprint_1.classNames)('Header-bentoItemLink-local', className, BentoItemLink_module_scss_1.default.linkItem), href: href }, dti, { children: children })));
};
exports.BentoItemLink = BentoItemLink;
